import { render, staticRenderFns } from "./specialHeader.vue?vue&type=template&id=51bb4b37"
import script from "./specialHeader.vue?vue&type=script&lang=js"
export * from "./specialHeader.vue?vue&type=script&lang=js"
import style0 from "./specialHeader.vue?vue&type=style&index=0&id=51bb4b37&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports